import { Container, Typography } from '@mui/material';

export default function StaticPage({ title, body }: { title: string; body?: string }) {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>{title}</Typography>
      {body && <Typography color="text.secondary">{body}</Typography>}
    </Container>
  );
}

